import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AddProductForm } from "./product-dialog/AddProductForm";

interface AddProductDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (product: any) => void;
  isPoultry?: boolean;  // Added this prop
}

export const AddProductDialog = ({
  isOpen,
  onOpenChange,
  onSubmit,
  isPoultry = false,  // Default to false
}: AddProductDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>
            {isPoultry ? "Ajouter un nouveau lot" : "Ajouter un nouveau produit"}
          </DialogTitle>
        </DialogHeader>
        <AddProductForm 
          onSubmit={onSubmit} 
          onCancel={() => onOpenChange(false)}
          isPoultry={isPoultry}
        />
      </DialogContent>
    </Dialog>
  );
};